import {
    DialogContent,
    DialogAwareContentContainer,
    DialogAwareButtonContainer,
    Button,
    Typography,
} from "@/components";
import { useState } from "react";
export interface JoinWaitlistDialogProps {
    onClose?: () => void;
}

export function JoinWaitlistDialog({ onClose }: JoinWaitlistDialogProps) {
    const [isSubmitting] = useState(false);

    const handleSubmit = async () => {
        onClose?.();
        window.location.reload();
    };

    return (
        <DialogContent>
            <DialogAwareContentContainer isDialog>
                <div className="space-y-4">
                    <Typography className="text-gray-300">Press submit to bypass this modal</Typography>
                </div>
            </DialogAwareContentContainer>

            <DialogAwareButtonContainer isDialog>
                <Button onClick={handleSubmit} disabled={isSubmitting} isLoading={isSubmitting} fullWidth>
                    {isSubmitting ? "Joining..." : "Submit"}
                </Button>
            </DialogAwareButtonContainer>
        </DialogContent>
    );
}
